import _ from 'lodash';
import PriceMatrixCell from 'pu-react/components/PriceMatrixCell';

class Cell extends PriceMatrixCell {
  // constructor(props) {
  //   super(props);
  // }

  isSelected() {
    const { parameters, lineItem } = this.props;
    if (parameters === undefined) {
      return false;
    }

    return (
      _.parseInt(parameters.row_selected) === this.props.row &&
      _.parseInt(parameters.column_selected) === this.props.col &&
      parameters.supplier_selected === lineItem.product_key &&
      _.parseInt(parameters.combined_selected) === _.parseInt(this.props.combined)
    );
  }
}

export default Cell;
